import styled from 'styled-components'

export const AccordionWrapper = styled.div`
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: ${props => props.background};
`

export const AccordionList = styled.ul`
  list-style-type: none;
`

export const AccordionLink = styled.div`
  ${({ alignLeft }) => {
    return alignLeft === true ? `text-align: left;` : `text-align: center;`
  }}
`
